import { MapPin } from "lucide-react";
import React from "react";

/** Split `text` on `query` (case-insensitive); matched parts render black+bold. */
function renderHighlighted(text: string, query?: string): React.ReactNode {
  const q = (query || "").trim();
  if (!q) return text;
  const escaped = q.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const parts = text.split(new RegExp(`(${escaped})`, "ig"));
  return parts.map((part, i) =>
    part.toLowerCase() === q.toLowerCase() ? (
      <span key={i} className='font-extrabold text-black'>
        {part}
      </span>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    ),
  );
}

interface DestinationItemProps {
  title: string;
  description?: string;
  onClick?: () => void;
  icon?: React.ReactNode;
  /** Icon container classes. Defaults to the grey rounded box; pass a plain
   *  value (e.g. "p-2") for a background-less icon. */
  iconWrapperClassName?: string;
  /** When set, occurrences of this text in the title are highlighted. */
  highlight?: string;
}

const DestinationItem: React.FC<DestinationItemProps> = ({
  title,
  description = "",
  onClick,
  icon = <MapPin className='text-slate' size={20} />,
  iconWrapperClassName = "p-1 bg-gray-100 rounded-lg",
  highlight,
}) => {
  return (
    <div
      className='flex items-center gap-1 py-1  hover:bg-gray-50 rounded-lg cursor-pointer transition-colors'
      onClick={onClick}
    >
      <div className={iconWrapperClassName}>{icon}</div>
      <div className='flex flex-col pr-2'>
        <span className='text-sm font-medium text-slate-800 line-clamp-1 '>
          {renderHighlighted(title, highlight)}
        </span>
        {description && (
          <span className='text-xs text-gray-400 line-clamp-1'>
            {description}
          </span>
        )}
      </div>
    </div>
  );
};

export default DestinationItem;
